"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
exports.view = view;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const GraphQLRequest = __importStar(require("@genesys/graphql-request"));
const variant_listing_state_1 = require("./variant-listing-state");
const React = __importStar(require("react"));
const ReactRedux = __importStar(require("react-redux"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Loaders = __importStar(require("@genesys/client-core/lib/loaders"));
const styled_components_1 = __importDefault(require("styled-components"));
const GenesysPropertiesSelectorHelpers = __importStar(require("@genesys/client-core/lib/genesys-properties-selector-helpers"));
const property_1 = require("@genesys/property");
const Exporter = __importStar(require("@genesys/client-core/lib/exporter"));
const Root = styled_components_1.default.div `
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;
const SettingsContainer = styled_components_1.default.div `
  flex: 0 0 auto;
  padding: 10px;
  > h3 {
    padding: 5px;
  }
  > div {
    padding: 5px;
  }
  > button {
    margin: 20px;
  }
`;
const ButtonContainer = styled_components_1.default.div `
  font-size: 12px;
  button {
    margin: 5px;
  }
`;
const PropertiesContainer = styled_components_1.default.div `
  flex: 0 0 auto;
`;
const PropertiesTable = styled_components_1.default.table `
  tr {
    td {
    }
  }
`;
const PropertyList = styled_components_1.default.ul `
  font-size: 12px;
`;
const PropertyHeader = styled_components_1.default.li `
  div {
    display: inline-block;
  }
`;
const PropertyValueItem = styled_components_1.default.li `
  margin: 10px;
`;
const ExpanderWithArrowLocal = (0, styled_components_1.default)(Elements.ExpanderWithArrow) `
  padding: 5px 0 5px 25px;
`;
const ResultContainer = styled_components_1.default.div `
  flex: 1 0 auto;
  button {
    margin: 20px 0;
  }
  textarea {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background: #ebebeb;
    box-sizing: border-box;
    resize: none;
  }
`;
// 
// const PropertiesContainer = styled.div`
//   padding: 20px;
//   table {
//     border: 1px solid #ddd;
//     display: block;
//     height: 300px;
//     overflow: auto;
//   }
// `;
const queryProducts = (0, graphql_tag_1.default) `
  query VariantListingAllProducts {
    product {
      activeSystemTypes {
        id
        allProducts {
          id
        }
      }
    }
  }
`;
const queryProduct = (0, graphql_tag_1.default) `
  query VariantListingProduct($productInput: GetProductInputType!) {
    product {
      product(input: $productInput) {
        id
        properties {
          id
          name
          sortNo
          quantity
          values {
            value
            sortNo
          }
        }
      }
    }
  }
`;
const getVariantListingPreValidationResultQuery = (0, graphql_tag_1.default) `
  query VariantListingPreValidationResult(
    $input: VariantListingPreValidationInputType!
  ) {
    product {
      getVariantListingPreValidationResult(input: $input) {
        ok
        errors
      }
    }
  }
`;
const getVariantListingResultQuery = (0, graphql_tag_1.default) `
  query VariantListingResult($input: VariantListingInputType!) {
    product {
      getVariantListingResult(input: $input) {
        message
        variants
      }
    }
  }
`;
const pleaseSelect = "please-select";
function view({ state, dispatch }) {
    return (React.createElement(Contexts.clientConfigContext.Consumer, null, config => (React.createElement(Contexts.TranslateContext.Consumer, null, translate => (React.createElement(GraphQLQuery.QueryProductSimple, { query: queryProducts, variables: {} }, allProducts => (React.createElement(Loaders.PleaseWaitOverlayLoaderIndicator, { active: state.loading },
        React.createElement(Loaders.ProgressOverlayLoaderIndicator, { active: state.generationProgress.inProgress, message: state.generationProgress.message, current: state.generationProgress.current, max: state.generationProgress.max },
            React.createElement(Root, null,
                React.createElement(Elements.ExpanderWithArrow, { isCollapsed: state.hideAllSettings, onToggle: () => {
                        dispatch(variant_listing_state_1.Action.VariantListingToggleHideSettings());
                    }, text: "Hide all inputs" }),
                !state.hideAllSettings && (React.createElement(SettingsContainer, null,
                    React.createElement("h3", null,
                        React.createElement("p", null, "Hi! This is an experimental tool for generating property value sets given the product definition"),
                        React.createElement("p", null, "NOTE !!! It is highly recommended to make sure your product has has been property validated before using this. !!!")),
                    React.createElement("div", null,
                        React.createElement(Elements.SelectBox, { value: state.settings.systemTypeId || pleaseSelect, onChange: e => {
                                dispatch(variant_listing_state_1.Action.VariantListingSetSettings(Object.assign(Object.assign({}, state.settings), { systemTypeId: e.target.value, productId: undefined, propertySelections: {} })));
                            } },
                            React.createElement("option", { value: pleaseSelect }, "Please select"),
                            allProducts.product.activeSystemTypes
                                .concat()
                                .sort((a, b) => a.id.localeCompare(b.id))
                                .map(p => (React.createElement("option", { key: p.id, value: p.id }, p.id)))),
                        state.settings.systemTypeId && (React.createElement(React.Fragment, null,
                            React.createElement(Elements.SelectBox, { value: state.settings.productId || pleaseSelect, onChange: e => {
                                    dispatch(variant_listing_state_1.Action.VariantListingSetSettings(Object.assign(Object.assign({}, state.settings), { productId: e.target.value, propertySelections: {} })));
                                } },
                                React.createElement("option", { value: pleaseSelect }, "Please select"),
                                allProducts.product.activeSystemTypes
                                    .flatMap(x => x.allProducts)
                                    .sort((a, b) => a.id.localeCompare(b.id))
                                    .filter(p => p.id.startsWith(state.settings.systemTypeId))
                                    .map(p => (React.createElement("option", { key: p.id, value: p.id }, p.id)))),
                            React.createElement("label", null,
                                "\u00A0SYS property value settings (will be used against Range Filters in the component):\u00A0",
                                React.createElement("input", { type: "text", size: 50, disabled: false, value: state.settings.rangeProperties || "", onChange: e => {
                                        dispatch(variant_listing_state_1.Action.VariantListingSetSettings(Object.assign(Object.assign({}, state.settings), { rangeProperties: e.target.value })));
                                    } }))))),
                    React.createElement(PropertiesContainer, null, state.settings.systemTypeId &&
                        state.settings.systemTypeId !== pleaseSelect &&
                        state.settings.productId &&
                        state.settings.productId !== pleaseSelect && (React.createElement(GraphQLQuery.QueryProductSimple, { query: queryProduct, variables: {
                            productInput: {
                                productId: state.settings.productId
                            }
                        } }, productData => {
                        let currentPropertySelections = {};
                        if (Object.keys(state.settings.propertySelections).length > 0) {
                            currentPropertySelections =
                                state.settings.propertySelections;
                        }
                        else {
                            currentPropertySelections =
                                getPropertySelectionsFromProductData(productData.product.product.properties);
                        }
                        const translation = GenesysPropertiesSelectorHelpers.createTranslation(translate, state.settings.productId);
                        return (React.createElement(React.Fragment, null,
                            React.createElement(ButtonContainer, null,
                                React.createElement(Elements.StandardButton, { disabled: false, onClick: () => {
                                        const newPropertySelections = collapseAllPropertySelections(currentPropertySelections);
                                        dispatch(variant_listing_state_1.Action.VariantListingSetSettings(Object.assign(Object.assign({}, state.settings), { propertySelections: newPropertySelections })));
                                    } }, "Collapse all properties"),
                                React.createElement(Elements.StandardButton, { disabled: false, onClick: () => {
                                        const newPropertySelections = setAllPropertySelections(currentPropertySelections, true);
                                        dispatch(variant_listing_state_1.Action.VariantListingSetSettings(Object.assign(Object.assign({}, state.settings), { propertySelections: newPropertySelections })));
                                    } }, "Select all properties"),
                                React.createElement(Elements.StandardButton, { disabled: false, onClick: () => {
                                        const newPropertySelections = setAllPropertySelections(currentPropertySelections, false);
                                        dispatch(variant_listing_state_1.Action.VariantListingSetSettings(Object.assign(Object.assign({}, state.settings), { propertySelections: newPropertySelections })));
                                    } }, "DeSelect all properties"),
                                React.createElement(Elements.StandardButton, { disabled: false, onClick: () => {
                                        const newPropertySelections = setAllPropertyValuesOnAllSelectedProperties(currentPropertySelections, true);
                                        dispatch(variant_listing_state_1.Action.VariantListingSetSettings(Object.assign(Object.assign({}, state.settings), { propertySelections: newPropertySelections })));
                                    } }, "Select all property values on all selected properties"),
                                React.createElement(Elements.StandardButton, { disabled: false, onClick: () => {
                                        const newPropertySelections = setAllPropertyValuesOnAllSelectedProperties(currentPropertySelections, false);
                                        dispatch(variant_listing_state_1.Action.VariantListingSetSettings(Object.assign(Object.assign({}, state.settings), { propertySelections: newPropertySelections })));
                                    } }, "Deselect all property values on all selected properties"),
                                React.createElement(Elements.StandardButton, { disabled: false, onClick: () => {
                                        const newPropertySelections = setFirstPropertyValueSelectedOnAllSelectedProperties(currentPropertySelections);
                                        dispatch(variant_listing_state_1.Action.VariantListingSetSettings(Object.assign(Object.assign({}, state.settings), { propertySelections: newPropertySelections })));
                                    } }, "Select first property value on all selected properties")),
                            React.createElement(PropertiesTable, null, Object.keys(currentPropertySelections).map(propertyKey => {
                                const currentPropertySelection = currentPropertySelections[propertyKey];
                                const currentPropertyValueSelections = Object.keys(currentPropertySelection.propertyValueSelections).map(key2 => {
                                    return currentPropertySelection
                                        .propertyValueSelections[key2];
                                });
                                const expanderText = `${translation.propertyName(currentPropertySelection.propertyName)}` +
                                    " " +
                                    `(${currentPropertySelection.propertyName})` +
                                    (currentPropertySelection.selected
                                        ? ` ${currentPropertyValueSelections.filter(v => v.selected).length}` +
                                            "/" +
                                            `${currentPropertyValueSelections.length}` +
                                            " selected."
                                        : "");
                                return (React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement(PropertyList, null,
                                            React.createElement(PropertyHeader, { key: currentPropertySelection.propertyName },
                                                React.createElement("input", { type: "checkbox", disabled: false, checked: currentPropertySelection.selected, onChange: () => {
                                                        const newPropertySelections = togglePropertySelectionOnPropertyName(currentPropertySelections, propertyKey);
                                                        dispatch(variant_listing_state_1.Action.VariantListingSetSettings(Object.assign(Object.assign({}, state.settings), { propertySelections: newPropertySelections })));
                                                    } }),
                                                React.createElement(ExpanderWithArrowLocal, { isCollapsed: currentPropertySelection.collapsed, onToggle: () => {
                                                        const newPropertySelections = togglePropertyCollapsedOnPropertyName(currentPropertySelections, propertyKey);
                                                        dispatch(variant_listing_state_1.Action.VariantListingSetSettings(Object.assign(Object.assign({}, state.settings), { propertySelections: newPropertySelections })));
                                                    }, text: expanderText })),
                                            !currentPropertySelection.collapsed &&
                                                Object.keys(currentPropertySelection.propertyValueSelections).map(propertyValueKey => {
                                                    const currentPropertyValueSelection = currentPropertySelection
                                                        .propertyValueSelections[propertyValueKey];
                                                    return (React.createElement(PropertyValueItem, { key: currentPropertySelection.propertyName +
                                                            "_" +
                                                            currentPropertyValueSelection.value },
                                                        React.createElement("input", { type: "checkbox", disabled: !currentPropertySelection.selected, checked: currentPropertyValueSelection.selected, onChange: () => {
                                                                const newPropertySelections = togglePropertyValueSelectionOnPropertyNameAndValue(currentPropertySelections, propertyKey, propertyValueKey);
                                                                dispatch(variant_listing_state_1.Action.VariantListingSetSettings(Object.assign(Object.assign({}, state.settings), { propertySelections: newPropertySelections })));
                                                            } }),
                                                        `${translation.propertyValue(currentPropertySelection.propertyName, currentPropertyValueSelection.value)}` +
                                                            " (" +
                                                            `${currentPropertyValueSelection.value}` +
                                                            ")"));
                                                }))),
                                    React.createElement("td", null,
                                        React.createElement(Elements.StandardButton, { disabled: !currentPropertySelection.selected, onClick: () => {
                                                const newPropertySelections = setAllPropertyValuesOnPropertyName(currentPropertySelections, propertyKey, true);
                                                dispatch(variant_listing_state_1.Action.VariantListingSetSettings(Object.assign(Object.assign({}, state.settings), { propertySelections: newPropertySelections })));
                                            } }, "Select all")),
                                    React.createElement("td", null,
                                        React.createElement(Elements.StandardButton, { disabled: !currentPropertySelection.selected, onClick: () => {
                                                const newPropertySelections = setAllPropertyValuesOnPropertyName(currentPropertySelections, propertyKey, false);
                                                dispatch(variant_listing_state_1.Action.VariantListingSetSettings(Object.assign(Object.assign({}, state.settings), { propertySelections: newPropertySelections })));
                                            } }, "DeSelect all")),
                                    React.createElement("td", null,
                                        React.createElement(Elements.StandardButton, { disabled: !currentPropertySelection.selected, onClick: () => {
                                                const newPropertySelections = setFirstValueSelectedOnPropertyName(currentPropertySelections, propertyKey);
                                                dispatch(variant_listing_state_1.Action.VariantListingSetSettings(Object.assign(Object.assign({}, state.settings), { propertySelections: newPropertySelections })));
                                            } }, "Select first"))));
                            }))));
                    }))),
                    React.createElement(Elements.StandardButton, { disabled: state.settings.productId === undefined ||
                            state.settings.productId === pleaseSelect, onClick: async () => {
                            dispatch(variant_listing_state_1.Action.VariantListingSetGenerationProgress(true, "Initialize", 0, 0));
                            dispatch(variant_listing_state_1.Action.VariantListingSetMessagesAndResults([], []));
                            dispatch(variant_listing_state_1.Action.VariantListingSetGenerationProgress(true, "Create property input", 1, 3));
                            const messages = [];
                            const selectedProperties = createInput(state.settings.propertySelections);
                            if (selectedProperties.length === 0) {
                                messages.push("No properties with property values selected.");
                                dispatch(variant_listing_state_1.Action.VariantListingSetMessagesAndResults(messages, []));
                                dispatch(variant_listing_state_1.Action.VariantListingSetGenerationProgress(false, "", 0, 0));
                                dispatch(variant_listing_state_1.Action.VariantListingHideSettings());
                                return;
                            }
                            dispatch(variant_listing_state_1.Action.VariantListingSetGenerationProgress(true, "Pre validate", 2, 3));
                            const systemTypeId = state.settings.systemTypeId;
                            const productId = state.settings.productId;
                            const rangeProperties = state.settings.rangeProperties || "";
                            const results = [];
                            const preValidationResult = await getPreValidationResult(systemTypeId, productId, rangeProperties, config.graphqlEndpoint, config.authorization);
                            if (!preValidationResult.product
                                .getVariantListingPreValidationResult.ok) {
                                messages.push(...preValidationResult.product
                                    .getVariantListingPreValidationResult.errors);
                                dispatch(variant_listing_state_1.Action.VariantListingSetMessagesAndResults(messages, []));
                                dispatch(variant_listing_state_1.Action.VariantListingSetGenerationProgress(false, "", 0, 0));
                                dispatch(variant_listing_state_1.Action.VariantListingHideSettings());
                                return;
                            }
                            dispatch(variant_listing_state_1.Action.VariantListingSetGenerationProgress(true, "Generating variants...", 3, 3));
                            const variantListinResult = await getVariantListingResult(productId, rangeProperties, selectedProperties, config.graphqlEndpoint, config.authorization);
                            messages.push(variantListinResult.product
                                .getVariantListingResult.message);
                            results.push(...variantListinResult.product.getVariantListingResult.variants.map(v => {
                                return property_1.PropertyValueSet.fromString(v);
                            }));
                            dispatch(variant_listing_state_1.Action.VariantListingSetMessagesAndResults(messages, results));
                            dispatch(variant_listing_state_1.Action.VariantListingSetGenerationProgress(false, "", 0, 0));
                            dispatch(variant_listing_state_1.Action.VariantListingHideSettings());
                        } }, "Generate variants"))),
                React.createElement(ResultContainer, null,
                    React.createElement(Exporter.XlsxSingleSheetExport, { data: getDataAsRawVariants(state.results), filename: state.settings.productId + "-RawVariants" }, onClick => (React.createElement(Elements.StandardButton, { disabled: state.results.length === 0, onClick: onClick }, "Export raw variants"))),
                    React.createElement(Exporter.XlsxSingleSheetExport, { data: getVariantsAsTableWithHeaders(state.results), filename: state.settings.productId + "-VariantsWithHeadings" }, onClick => (React.createElement(Elements.StandardButton, { disabled: state.results.length === 0, onClick: onClick }, "Export variants with headings"))),
                    React.createElement("textarea", { readOnly: true, value: state.messages.join("\n") }))))))))))));
}
function getPreValidationResult(systemTypeId, productId, rangeProperties, endpoint, authorization) {
    return GraphQLRequest.request(getVariantListingPreValidationResultQuery, {
        input: {
            systemTypeId: systemTypeId,
            productId: productId,
            rangeProperties: rangeProperties
        }
    }, true, endpoint, authorization);
}
function createInput(selectedProperties) {
    const properties = Object.keys(selectedProperties).reduce((propertiesSoFar, propertyKey) => {
        const propertySelection = selectedProperties[propertyKey];
        if (propertySelection.selected) {
            const values = Object.keys(propertySelection.propertyValueSelections).reduce((valuesSoFar, valueKey) => {
                const propertyValueSelection = propertySelection.propertyValueSelections[valueKey];
                if (propertyValueSelection.selected) {
                    valuesSoFar.push(propertyValueSelection.value);
                }
                return valuesSoFar;
            }, []);
            if (values.length > 0) {
                propertiesSoFar.push({
                    propertyName: propertySelection.propertyName,
                    values: values
                });
            }
        }
        return propertiesSoFar;
    }, []);
    return properties;
}
function getVariantListingResult(productId, rangeProperties, selectedProperties, endpoint, authorization) {
    return GraphQLRequest.request(getVariantListingResultQuery, {
        input: {
            productId: productId,
            rangeProperties: rangeProperties,
            selectedProperties: selectedProperties
        }
    }, true, endpoint, authorization);
}
function getDataAsRawVariants(variants) {
    return variants.map(v => {
        const row = [];
        row.push(property_1.PropertyValueSet.toString(v));
        return row;
    });
}
function getVariantsAsTableWithHeaders(variants) {
    const propertyNames = variants.reduce((propertyNamesSoFar, current) => {
        property_1.PropertyValueSet.getPropertyNames(current).forEach(pn => {
            if (!propertyNamesSoFar.some(p => p === pn)) {
                propertyNamesSoFar.push(pn);
            }
        });
        return propertyNamesSoFar;
    }, []);
    const table = [];
    table.push(propertyNames);
    const rows = variants.map(v => {
        const row = [];
        propertyNames.forEach(pn => {
            if (property_1.PropertyValueSet.hasProperty(pn, v)) {
                row.push(property_1.PropertyValueSet.getInteger(pn, v).toString());
            }
            else {
                row.push("");
            }
        });
        return row;
    });
    table.push(...rows);
    return table;
}
function getPropertySelectionsFromProductData(properties) {
    return properties
        .filter(p => p.quantity === "Discrete")
        .sort((a, b) => ((a.sortNo || 0) < (b.sortNo || 0) ? -1 : 1))
        .reduce((propertiesSoFar, currentProperty) => {
        const propertyValueSelections = currentProperty.values
            .concat()
            .sort((a, b) => ((a.sortNo || 0) < (b.sortNo || 0) ? -1 : 1))
            .reduce((valuesSoFar, currentPropertyValue) => {
            const value = parseInt(currentPropertyValue.value, 10);
            const propertyValueSelection = {
                selected: false,
                value: value
            };
            valuesSoFar[value] = propertyValueSelection;
            return valuesSoFar;
        }, {});
        const propertySelection = {
            propertyName: currentProperty.name,
            selected: false,
            collapsed: true,
            propertyValueSelections: propertyValueSelections
        };
        propertiesSoFar[currentProperty.name] = propertySelection;
        return propertiesSoFar;
    }, {});
}
function togglePropertySelectionOnPropertyName(propertySelections, propertyName) {
    const newPropertySelections = propertySelections;
    const propertySelection = newPropertySelections[propertyName];
    let newPropertyValueSelections = propertySelection.propertyValueSelections;
    if (propertySelection.selected) {
        newPropertyValueSelections = setAllPropertyValueSelections(newPropertyValueSelections, false);
    }
    newPropertySelections[propertyName] = Object.assign(Object.assign({}, propertySelection), { selected: !propertySelection.selected, propertyValueSelections: newPropertyValueSelections });
    return newPropertySelections;
}
function togglePropertyValueSelectionOnPropertyNameAndValue(propertySelections, propertyName, propertyValue) {
    const newPropertySelections = propertySelections;
    const propertySelection = newPropertySelections[propertyName];
    const newPropertyValueSelections = propertySelection.propertyValueSelections;
    newPropertyValueSelections[propertyValue] = Object.assign(Object.assign({}, newPropertyValueSelections[propertyValue]), { selected: !newPropertyValueSelections[propertyValue].selected });
    newPropertySelections[propertyName] = Object.assign(Object.assign({}, propertySelection), { propertyValueSelections: newPropertyValueSelections });
    return newPropertySelections;
}
function togglePropertyCollapsedOnPropertyName(propertySelections, propertyNamne) {
    const newPropertySelections = propertySelections;
    const propertySelection = newPropertySelections[propertyNamne];
    newPropertySelections[propertyNamne] = Object.assign(Object.assign({}, propertySelection), { collapsed: !propertySelection.collapsed });
    return newPropertySelections;
}
function collapseAllPropertySelections(propertySelections) {
    const newPropertySelections = propertySelections;
    Object.keys(newPropertySelections).forEach(key => {
        const propertySelection = newPropertySelections[key];
        newPropertySelections[key] = Object.assign(Object.assign({}, propertySelection), { collapsed: true });
    });
    return newPropertySelections;
}
function setAllPropertySelections(propertySelections, selected) {
    const newPropertySelections = propertySelections;
    Object.keys(newPropertySelections).forEach(key => {
        const propertySelection = newPropertySelections[key];
        let newPropertyValueSelections = propertySelection.propertyValueSelections;
        if (!selected) {
            newPropertyValueSelections = setAllPropertyValueSelections(newPropertyValueSelections, false);
        }
        newPropertySelections[key] = Object.assign(Object.assign({}, propertySelection), { selected: selected, propertyValueSelections: newPropertyValueSelections });
    });
    return newPropertySelections;
}
function setAllPropertyValuesOnAllSelectedProperties(propertySelections, selected) {
    const newPropertySelections = propertySelections;
    Object.keys(newPropertySelections).forEach(key => {
        const propertySelection = newPropertySelections[key];
        let newPropertyValueSelections = propertySelection.propertyValueSelections;
        if (propertySelection.selected) {
            newPropertyValueSelections = setAllPropertyValueSelections(newPropertyValueSelections, selected);
        }
        newPropertySelections[key] = Object.assign(Object.assign({}, propertySelection), { propertyValueSelections: newPropertyValueSelections });
    });
    return newPropertySelections;
}
function setAllPropertyValuesOnPropertyName(propertySelections, propertyNamne, selected) {
    const newPropertySelections = propertySelections;
    const propertySelection = newPropertySelections[propertyNamne];
    let newPropertyValueSelections = propertySelection.propertyValueSelections;
    if (propertySelection.selected) {
        newPropertyValueSelections = setAllPropertyValueSelections(newPropertyValueSelections, selected);
    }
    newPropertySelections[propertyNamne] = Object.assign(Object.assign({}, propertySelection), { propertyValueSelections: newPropertyValueSelections });
    return newPropertySelections;
}
function setAllPropertyValueSelections(propertyValueSelections, selected) {
    const newPropertyValueSelections = propertyValueSelections;
    Object.keys(newPropertyValueSelections).forEach(key => {
        newPropertyValueSelections[key] = Object.assign(Object.assign({}, newPropertyValueSelections[key]), { selected: selected });
    });
    return newPropertyValueSelections;
}
function setFirstPropertyValueSelectedOnAllSelectedProperties(propertySelections) {
    const newPropertySelections = propertySelections;
    Object.keys(newPropertySelections).forEach(key => {
        const propertySelection = newPropertySelections[key];
        let newPropertyValueSelections = propertySelection.propertyValueSelections;
        if (propertySelection.selected) {
            newPropertyValueSelections = setFirstPropertyValueSelected(newPropertyValueSelections);
        }
        newPropertySelections[key] = Object.assign(Object.assign({}, propertySelection), { propertyValueSelections: newPropertyValueSelections });
    });
    return newPropertySelections;
}
function setFirstValueSelectedOnPropertyName(propertySelections, propertyNamne) {
    const newPropertySelections = propertySelections;
    const propertySelection = newPropertySelections[propertyNamne];
    let newPropertyValueSelections = propertySelection.propertyValueSelections;
    if (propertySelection.selected) {
        newPropertyValueSelections = setFirstPropertyValueSelected(newPropertyValueSelections);
    }
    newPropertySelections[propertyNamne] = Object.assign(Object.assign({}, propertySelection), { propertyValueSelections: newPropertyValueSelections });
    return newPropertySelections;
}
function setFirstPropertyValueSelected(propertyValueSelections) {
    const newPropertyValueSelections = propertyValueSelections;
    Object.keys(newPropertyValueSelections).forEach((key, index) => {
        const selected = index === 0;
        newPropertyValueSelections[key] = Object.assign(Object.assign({}, newPropertyValueSelections[key]), { selected: selected });
    });
    return newPropertyValueSelections;
}
exports.View = ReactRedux.connect((state) => ({ state: state.ui.variantListing }))(view);
//# sourceMappingURL=variant-listing-view.js.map